export default __webpack_public_path__ + "static/lysicrates-logo-3748acf8d98411f06a727486f7759c0e.svg";